import React, {FC} from 'react';

import {CtaButton} from '@optimaxdev/design-system';

/**
 * Button for smart doctor screen
 */
export const Button: FC<{onClick: () => void; isLoading?: boolean}> = ({isLoading, onClick}) => (
    <CtaButton colorName="secondary" isLoading={isLoading} onClick={onClick} size="medium">
        Confirm & Continue
    </CtaButton>
);
